import type { DatasetFileUploadProps } from "./dataset-file-upload.type";

import UploadFile from "@/modules/upload-file";

import { useDatasetFileUpload } from "./dataset-file-upload.hook";

const DatasetFileUpload = (props: DatasetFileUploadProps) => {
  const { uploadProps } = useDatasetFileUpload(props);

  return (
    <UploadFile
      layout="draggerRow"
      data-testid="dataset-file-upload"
      {...uploadProps}
    />
  );
};

export default DatasetFileUpload;
